var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',{attrs:{"label":_vm.label}},[_c('BaseMarkdownEditor',{staticStyle:{"width":"100%","height":"100%"},attrs:{"type":"textarea","option":_vm._config,"preview":!_vm.editable,"placeholder":_vm._config.placeholder || '请输入'},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }